<template>
  <v-app>
    <v-card width="full-width" style="max-height: 460px" elevation="0">
      <v-container fluid>
        <v-row>
          <v-col cols="12" sm="6" md="1" class="pa-1">
            <v-checkbox v-model="checkboxInclude" label="Include Closed" class="ma-4 mt-2"></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateFormattedView"
                  label="From"
                  hint="MM/DD/YYYY Format"
                  append-icon="event"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
                <!-- @blur="dateFrom = parseDate(dateFormatted)" -->
              </template>
              <v-date-picker v-model="dateFormatted" @input="menu2 = false"></v-date-picker>
            </v-menu>
          </v-col>

          <!--Search To Field-->
          <v-col cols="12" sm="6" md="2">
            <v-menu
              ref="menu4"
              v-model="menu4"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateFormatted1"
                  label="To"
                  hint="MM/DD/YYYY Format"
                  append-icon="event"
                  @blur="date1 = parseDate(dateFormatted1)"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-date-picker v-model="date1" @input="menu4 = false"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="6" md="1">
            <v-btn
              dark
              class="mr-2"
              color="primary"
              :loading="tableLoading"
              @click="getAllSurveyByOrgID('Go')"
            >Go</v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="1"></v-col>
          <!--Check Box Field-->

          <v-col cols="12" sm="6" md="2">
            <v-text-field class="pt-0" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-combobox
              :items="priorityListDemo"
              v-model="stateStatus"
              @change="getChangeStateStatus(stateStatus)"
              item-text="name"
              label="Select Priority"
              dense
              outlined
            >
              <template slot="item" slot-scope="data">
                <v-icon :color="getColor(data.item.value)" dark dense>fiber_manual_record</v-icon>
                {{ data.item.name}}
              </template>
            </v-combobox>
          </v-col>
          <!-- To add new Surveys -->
          <v-col cols="12" sm="1">
            <!-- <v-text-field v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field> -->
            <v-btn color="primary" @click="dialog = true" dark>Add</v-btn>
            <v-dialog v-model="dialog" persistent max-width="900px">
              <v-card>
                <v-card-title class="secondary">
                  <span class="title white--text">Register Surveys/Claims</span>
                  <v-spacer></v-spacer>
                  <v-icon @click="registerDialog()" class="white--text">mdi-close</v-icon>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-row>
                        <v-col cols="12" sm="6" md="3">
                          <v-select
                            :items="sourceByID"
                            v-model="sourceAdd"
                            :rules="[rules.required]"
                            item-text="source_name"
                            item-value="source_id"
                            label="Source*"
                            dense
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            label="Reference Number*"
                            :maxlength="maxRef"
                            @input="getReferenceNumValidation()"
                            :error-messages="usernameError"
                            v-model="referenceNumberAdd"
                            :rules="[rules.required,rules.specialCharecter]"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                dense
                                v-model="formatDateAdd"
                                label="Claim/App Date*"
                                append-icon="event"
                                @blur="dateAdd = parseDate(formatDateAdd)"
                                v-on="on"
                                :rules="[rules.required]"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="dateAdd" @input="menu = false"></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-select
                            :items="surveyTypes"
                            v-model="typeAdd"
                            item-text="surveytype_name"
                            item-value="surveytype_id"
                            label="Type*"
                            :rules="[rules.required]"
                            dense
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            label="Company Name*"
                            :maxlength="max"
                            v-model="companyNameAdd"
                            dense
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            label="First Name*"
                            :maxlength="max"
                            v-model="firstNameAdd"
                            dense
                            :rules="[rules.required,rules.namerules]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            label="Last Name*"
                            :maxlength="max"
                            v-model="lastNameAdd"
                            dense
                            :rules="[rules.required,rules.namerules]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            label="Location Address*"
                            :maxlength="max"
                            v-model="addressAdd"
                            dense
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            label="City*"
                            :rules="[rules.required]"
                            :maxlength="max"
                            v-model="cityAdd"
                            dense
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            label="State*"
                            :maxlength="max"
                            :rules="[rules.required]"
                            v-model="stateAdd"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            label="County*"
                            :maxlength="max"
                            :rules="[rules.required]"
                            v-model="countyAdd"
                            dense
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            label="ZIP*"
                            :rules="[rules.required,rules.zipNumber]"
                            v-model="zipAdd"
                            dense
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                          <v-select
                            label="Country Code*"
                            :items="contryList"
                            item-text="countryWithCC"
                            :rules="[rules.required]"
                            item-value="dial_cc"
                            v-model="cCode"
                            dense
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            label="Cell Phone Number*"
                            :rules="[rules.required, rules.counterNumber,rules.contactNumber]"
                            v-model="contactAdd"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-select
                            :items="causeofLossById"
                            v-model="causeOfLossAdd"
                            item-text="cause_ofloss_name"
                            item-value="cause_ofloss_id"
                            label="Cause Of Loss*"
                            dense
                            :rules="[rules.required]"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            label="Contact Email*"
                            :rules="[rules.required, rules.email]"
                            v-model="emailAdd"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-select
                            label="Country Code"
                            :items="contryList"
                            item-text="countryWithCC"
                            item-value="dial_cc"
                            v-model="alternateCCode"
                            dense
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            label="Alternate Number"
                            :rules="[rulesforAlternate.contactNumber]"
                            v-model="contactAddOption"
                            :maxlength="max_num"
                            dense
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                          <v-select
                            :items="adminsList"
                            v-model="adminsListAdd"
                            item-text="name"
                            item-value="adminid"
                            label="Home Office Admin"
                            dense
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-select
                            :items="priorityList"
                            v-model="priorityAd"
                            item-text="name"
                            item-value="value"
                            label="Priority*"
                            :rules="[rules.required]"
                            dense
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" class="mt-n4">
                          <v-file-input
                            chips
                            v-model="fileupload"
                            multiple
                            accept="application/pdf"
                            label="Attach Pdf"
                          ></v-file-input>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    class="secondary white--text"
                    text
                    :loading="loading2"
                    :disabled="loading2"
                    @click="addClaim"
                    id="Register_Claim"
                  >Register Claim</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="editdialog" persistent max-width="900px">
              <v-card>
                <v-card-title class="secondary" v-if="readonlyView == true">
                  <span class="title white--text">View</span>
                  <v-spacer></v-spacer>
                  <v-icon @click="editSurveys()" class="white--text">mdi-close</v-icon>
                </v-card-title>
                <v-card-title class="secondary" v-if="readonlyView != true">
                  <span class="title white--text">Edit Surveys/Claims</span>
                  <v-spacer></v-spacer>
                  <v-icon @click="editSurveys()" class="white--text">mdi-close</v-icon>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form ref="form1" v-model="valid1" lazy-validation>
                      <v-row>
                        <v-col cols="12" sm="6" md="3">
                          <v-select
                            :items="sourceByID"
                            v-model="editSource"
                            item-text="source_name"
                            item-value="source_id"
                            label="Source*"
                            :rules="[rules.required]"
                            :readonly="readonlyView == true"
                            dense
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            label="Reference Number*"
                            v-model="editReferenceNumber"
                            readonly
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-menu
                            ref="menu5"
                            v-model="menu5"
                            :readonly="readonlyView == true"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                dense
                                :readonly="readonlyView == true"
                                v-model="formatEditDate"
                                label="Claim/App Date*"
                                append-icon="event"
                                :rules="[rules.required]"
                                @blur="editDate = parseDate(formatEditDate)"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="editDate" @input="menu5 = false"></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-select
                            :readonly="readonlyView == true"
                            :items="surveyTypes"
                            v-model="editType"
                            :rules="[rules.required]"
                            item-text="surveytype_name"
                            item-value="surveytype_id"
                            label="Type*"
                            dense
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            :readonly="readonlyView == true"
                            label="Company Name*"
                            :maxlength="max"
                            :rules="[rules.required]"
                            v-model="editCompanyName"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            label="First Name*"
                            :readonly="readonlyView == true"
                            :rules="[rules.required,rules.namerules]"
                            v-model="editFirstName"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            label="Last Name*"
                            :rules="[rules.required,rules.namerules]"
                            :readonly="readonlyView == true"
                            v-model="editLastName"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            label="Location Address*"
                            :rules="[rules.required]"
                            :readonly="readonlyView == true"
                            v-model="editAddress"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            label="City*"
                            :rules="[rules.required]"
                            :readonly="readonlyView == true"
                            v-model="editCity"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            label="County*"
                            :rules="[rules.required]"
                            :readonly="readonlyView == true"
                            v-model="editCounty"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            label="State*"
                            :rules="[rules.required]"
                            :readonly="readonlyView == true"
                            v-model="editState"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            label="ZIP*"
                            :rules="[rules.required,rules.zipNumber]"
                            :readonly="readonlyView == true"
                            v-model="editZip"
                            dense
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                          <v-select
                            :readonly="readonlyView == true"
                            :rules="[rules.required]"
                            label="Country Code*"
                            :items="contryList"
                            v-model="editCCode"
                            item-text="countryWithCC"
                            item-value="dial_cc"
                            dense
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            :readonly="readonlyView == true"
                            label="Cell Phone Number*"
                            :rules="[rules.required,rules.contactNumber]"
                            v-model="editContact"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-select
                            :items="causeofLossById"
                            v-model="editCauseOfLoss"
                            :readonly="readonlyView == true"
                            :rules="[rules.required]"
                            item-text="cause_ofloss_name"
                            item-value="cause_ofloss_id"
                            label="Cause Of Loss*"
                            dense
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            :readonly="readonlyView == true"
                            label="Contact Email*"
                            v-model="editEmail"
                            :rules="[rules.required, rules.email]"
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-select
                            :readonly="readonlyView == true"
                            label="Country Code"
                            v-model="editAlternateCode"
                            :items="contryList"
                            item-text="countryWithCC"
                            item-value="dial_cc"
                            dense
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field
                            :readonly="readonlyView == true"
                            label="Alternate Number"
                            data-type="int"
                            v-model="editAlternate"
                            dense
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                          <v-select
                            :readonly="readonlyView == true"
                            :items="adminsList"
                            v-model="editAdmin"
                            item-text="name"
                            item-value="adminid"
                            label="Home Office Admin"
                            dense
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-select
                            :readonly="readonlyView == true"
                            v-model="editPriority"
                            :items="priorityList"
                            :rules="[rules.required]"
                            item-text="name"
                            item-value="value"
                            label="Priority"
                            dense
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="12" class="mt-n4" v-if="chip1==false">
                          <v-file-input
                            :disabled="readonlyView == true"
                            chips
                            v-model="pdfChip"
                            multiple
                            accept="application/pdf"
                            label="Attach Pdf"
                          ></v-file-input>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" v-else>
                          <v-chip
                            :disabled:close="readonlyView == true"
                            class="ma-2"
                            @click:close="chipsMethod(readonlyView)"
                            @click="downloadPdf()"
                            close
                          >PDF Document</v-chip>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    v-if="readonlyView != true"
                    class="secondary white--text"
                    text
                    @click="updateClaim"
                    :loading="loading3"
                    :disabled="loading3 "
                    id="Register_Claim"
                  >Update Survey/Claim</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="serviorWithdraw" max-width="350">
              <v-card>
                <v-spacer></v-spacer>
                <v-card-subtitle
                  class="pa-4 font-weight-black"
                  style="font-size:16px"
                >Are you sure you want to withdraw the survey from the assigned surveryor ?</v-card-subtitle>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="green darken-1" text @click="backmethod()">Cancel</v-btn>

                  <v-btn color="green darken-1" text @click="surveyWithdraw()">Ok</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="serviorDelete" max-width="350">
              <v-card>
                <v-spacer></v-spacer>
                <v-card-subtitle
                  class="pa-4 font-weight-black"
                  style="font-size:16px"
                >Are you sure you want to Delete the survey from the withdraw surveryor ?</v-card-subtitle>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="green darken-1" text @click="backmethod()">Cancel</v-btn>

                  <v-btn color="green darken-1" text @click="surveyDelete()">Ok</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="assignSurveyor" max-width="1000px">
              <AsignSurveyor
                :user="user"
                :serveId="serveId"
                v-on:backEdit="backmethod"
                v-on:alertSuccess="alertSuccessMethod"
              />
            </v-dialog>
            <v-dialog v-model="activityLogStatus" max-width="800px">
              <ActivityLog :activityLogTable="activityLogTable" v-on:backEdit="backmethod()" />
            </v-dialog>
            <v-dialog v-model="reOpenStatus" max-width="700px">
              <ReOpenMenu
                :rowdetails="rowdetails"
                v-on:alertSuccess="alertSuccessMethod"
                v-on:alertError="alertErrorMethod"
                v-on:backEdit="backmethod()"
              />
            </v-dialog>
            <v-dialog v-model="serveyDetails" max-width="900px">
              <ServeyDetail
                :serveyDetailsArray="serveyDetailsArray"
                v-on:backEdit="backmethodServeyDetails()"
              />
            </v-dialog>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-content>
      <v-data-table
        :headers="headers"
        :items="claimTableData"
        :search="search"
        :options.sync="options"
        :loading="tableLoading"
        :disable="tableLoading"
        class="elevation-10 caption"
        :items-per-page="10"
      >
        <!--Table cloumns style-->
        <template v-slot:item.survery_date="{ item }">
          <span class="caption">{{ item.survery_date }}</span>
        </template>
        <template v-slot:item.survey_claimed_source="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span class="caption text_ellipsis" v-on="on">{{ item.survey_claimed_source}}</span>
            </template>
            <span>{{ item.survey_claimed_source }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.reference_number="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-chip :color="getColor(item.priority)" dark dense>
                <span class="caption text_ellipsis" v-on="on">{{ item.reference_number}}</span>
              </v-chip>
            </template>
            <span>{{ item.reference_number }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.claimed_firstname="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span class="caption text_ellipsis" v-on="on">{{ item.claimed_firstname}}</span>
            </template>
            <span>{{ item.claimed_firstname }}</span>
          </v-tooltip>
        </template>

        <template v-slot:item.survey_claimed_lastname="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span class="caption text_ellipsis" v-on="on">{{ item.survey_claimed_lastname}}</span>
            </template>
            <span>{{ item.survey_claimed_lastname }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.city="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span class="caption text_ellipsis" v-on="on">{{ item.city}}</span>
            </template>
            <span>{{ item.city }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.country="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span class="caption text_ellipsis" v-on="on">{{ item.country}}</span>
            </template>
            <span>{{ item.country }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.state="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span class="caption text_ellipsis" v-on="on">{{ item.state}}</span>
            </template>
            <span>{{ item.state }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.cause_of_loss_id="{ item }">
          <span class="caption">{{ item.cause_of_loss_id }}</span>
        </template>
        <template v-slot:item.survey_claimdate="{ item }">
          <span class="caption">{{ item.survey_claimdate }}</span>
        </template>
        <template v-slot:item.current_status="{ item }">
          <span class="caption">{{ item.current_status }}</span>
        </template>
        <template v-slot:item.iscompleted="{ item }">
          <span class="caption">{{ item.iscompleted }}</span>
        </template>

        <template v-slot:item.surveyor_name="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span class="caption text_ellipsis" v-on="on">{{ item.surveyor_name}}</span>
            </template>
            <span>{{ item.surveyor_name }}</span>
          </v-tooltip>
        </template>
        <!--For last column Drop down menu-->
        <template v-slot:item.Action="{item}">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon background-color="transparent" flat>mdi-view-dashboard</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-if="item.current_status=='Assigned' || item.current_status=='Accepted' ||  item.current_status=='Unassigned'  || item.current_status=='Ongoing' || item.current_status=='Reject' || item.current_status=='Withdraw'"
              >
                <v-list-item-title @click="actionMethod(item,'View/Edit')">View/Edit</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="item.current_status=='Unassigned' ||  item.current_status=='Reject' || item.current_status=='Withdraw'"
              >
                <v-list-item-title @click="actionMethod(item,'Assign surveyor')">Assign surveyor</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="item.current_status=='Completed' || item.current_status=='Ongoing'"
              >
                <v-list-item-title @click="actionMethod(item,'Survey Details')">Survey Details</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="item.current_status=='Completed'">
                <v-list-item-title @click="actionMethod(item,'View')">View</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="item.current_status=='Completed'">
                <v-list-item-title @click="actionMethod(item,'Re-Open')">Re-Open</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="item.current_status=='Assigned' || item.current_status=='Accepted' ||  item.current_status=='Unassigned'  || item.current_status=='Ongoing' || item.current_status=='Reject' || item.current_status=='Withdraw' || item.current_status=='Completed'"
              >
                <v-list-item-title @click="actionMethod(item,'Activity Log')">Activity Log</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="item.current_status=='Withdraw' ">
                <v-list-item-title @click="actionMethod(item,'Survey Details')">Delete</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-content>
    <v-snackbar
      v-model="alertPositive"
      color="secondary"
      :timeout="timeout"
      bottom="bottom"
    >{{ text }}</v-snackbar>
    <v-snackbar
      v-model="alertNegetive"
      color="primary"
      :timeout="timeout"
      bottom="bottom"
    >{{ text }}</v-snackbar>
  </v-app>
</template>  
<script>
import CountryJSON from "@/components/Country.json";
import axios from "axios";
import ActivityLog from "../views/MangesurveySubFolder/ActivityLog.vue";
import ReOpenMenu from "../views/MangesurveySubFolder/ReOpen.vue";
import moment from "moment";
import AsignSurveyor from "../views/AssignServior.vue";
import ServeyDetail from "../views/Surveydetails.vue";
var aws = require("aws-sdk");
export default {
  components: {
    AsignSurveyor,
    ServeyDetail,
    ActivityLog,
    ReOpenMenu
  },
  data: vm => ({
    max: 30,
    stateStatus: "",
    max_num: 15,
    pdfChip: "",
    chip1: false,
    valid: true,
    valid1: true,
    loading2: false,
    loading3: false,
    loader: null,
    loading: false,
    serviorDelete: false,
    user: "",
    search: "",
    serviorWithdraw: false,
    serveyDetails: false,
    serveyDetailsArray: [],
    assignSurveyor: false,
    activityLogStatus: false,
    reOpenStatus: false,
    rowdetails: "",
    activityLogTable: [],
    menu5: false,
    editSource: "",
    editReferenceNumber: "",
    editDate: new Date().toISOString().substr(0, 10),
    editType: "",
    editCompanyName: "",
    editFirstName: "",
    fileupload: [],
    editLastName: "",
    editAddress: "",
    editCity: "",
    editCounty: "",
    editZip: "",
    editAlternate: "",
    editCauseOfLoss: "",
    editAlternateCode: "Select Country Code",
    editFileupload: "",
    editCCode: "",
    editEmail: "",
    editPriority: "",
    items: [
      { title: "Click Me" },
      { title: "Click Me" },
      { title: "Click Me" },
      { title: "Click Me 2" }
    ],
    priorityListDemo: [
      { name: "All", value: "4" },
      { name: "Emergency", value: "3" },
      { name: "High", value: "2" },
      { name: "Medium", value: "1" },
      { name: "Low", value: "0" }
    ],
    priorityList: [
      { name: "Emergency", value: "3" },
      { name: "High", value: "2" },
      { name: "Medium", value: "1" },
      { name: "Low", value: "0" }
    ],
    editAdmin: "",
    editWebsite: "",
    editContact: "",
    editState: "",
    text: "",
    action: "",

    readonlyView: false,
    editdialog: false,
    timeout: 2300,

    alertNegetive: false,
    alertPositive: false,
    menu: false,
    checkbox: false,
    dialog: false,

    /*For Picking up the date for search */
    // dateFrom: new Date().toISOString().substr(0, 10),
    date1: new Date().toISOString().substr(0, 10),
    dateAdd: new Date().toISOString().substr(0, 10),
    dateFormatted: "",
    // dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    formatEditDate: vm.formatDate(new Date().toISOString().substr(0, 10)),
    modal: false,
    menu2: false,

    /*For Picking up the date To search */
    formatDateAdd: vm.formatDate(new Date().toISOString().substr(0, 10)),
    dateFormatted1: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu3: false,
    modal2: false,
    checkboxInclude: true,
    menu4: false,

    /*For last column to add drop down menu */
    snack: false,
    path: "Accept",

    pagination: {
      sortBy: "Status"
    },
    rulesforAlternate: {
      contactNumber: v => {
        const pattern = /^[0-9][0-9]{7,14}$/;
        return (
          pattern.test(v) || v.length == 0 || "Only Numeric,Min-7 & Max-15 "
        );
      }
    },
    rules: {
      required: v => !!v || "Required.",
      namerules: value => {
        const pattern = /^([a-zA-Z]+\s)*[a-zA-Z]+$/;
        return pattern.test(value) || "Only alphabets are allowed";
      },
      specialCharecterSpace: v => {
        const pattern = /[^-\s]+$/;
        return pattern.test(v) || "Spaces Not Allowed";
      },
      counter: v => v.length <= 20 || "Max 20 characters",
      counterNumber: v => v.length <= 15 || "Max 15 characters",
      email: v => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(v) || "Invalid e-mail";
      },
      contactNumber: v => {
        const pattern = /^[0-9][0-9]{7,14}$/;
        return pattern.test(v) || "Only Numeric,Min-7 & Max-15 ";
      },
      zipNumber: v => {
        const pattern = /^[0-9][0-9]{4,14}$/;
        return pattern.test(v) || "Only Numeric,Min-5 & Max-15 ";
      },
      specialCharecter: v => {
        const pattern = /^[A-Za-z0-9]+$/;
        return pattern.test(v) || "Special Characters Not Allowed ";
      }
    },
    selected: [],

    options: {},
    headers: [
      {
        text: "Date Created",
        value: "survery_date",
        class: "grey lighten-2"
      },
      {
        text: "Source",
        value: "survey_claimed_source",
        class: "grey lighten-2"
      },
      {
        text: "Ref #",
        value: "reference_number",
        class: "grey lighten-2"
      },
      {
        text: "First",
        value: "claimed_firstname",
        class: "grey lighten-2"
      },
      {
        text: "Last",
        value: "survey_claimed_lastname",
        class: "grey lighten-2"
      },
      {
        text: "City",
        value: "city",
        class: "grey lighten-2"
      },
      {
        text: "County",
        value: "country",
        sortable: false,
        class: "grey lighten-2"
      },
      {
        text: "State",
        value: "state",
        sortable: false,
        class: "grey lighten-2"
      },
      {
        text: "Cause",
        value: "cause_of_loss_id",
        class: "grey lighten-2"
      },
      {
        text: "Claim Date",
        value: "survey_claimdate",
        class: "grey lighten-2"
      },
      {
        text: "Status",
        value: "current_status",
        class: "grey lighten-2"
      },
      {
        text: "Completed On",
        value: "iscompleted",
        class: "grey lighten-2"
      },
      {
        text: "Surveyor",
        value: "surveyor_name",
        class: "grey lighten-2"
      },
      {
        text: "Action",
        value: "Action",
        sortable: false,
        class: "grey lighten-2"
      },
      {
        text: "Priority",
        value: "priority_text",
        align: " d-none",
        sortable: false,
        class: "grey lighten-2"
      }
    ],
    /*Action List for last column */

    ActionList: ["View/Edit", "Assign surveyor", "Withdraw", "Survey Details"],

    filters: {
      search: "",
      added_by: "",
      search1: ""
    },
    /*For adding new row in the table */
    sortDesc: false,
    claimTableData: [],
    claimTableDataDemo: [],
    editedIndex: -1,
    priorityAd: "",
    adminsListAdd: "",
    sourceAdd: "",
    maxRef: 10,
    referenceNumberAdd: "",
    survey_id: "",
    typeAdd: "",
    editSurvey_id: "",
    companyNameAdd: "",
    firstNameAdd: "",
    responseData: "",
    lastNameAdd: "",
    addressAdd: "",
    cityAdd: "",
    countyAdd: "",
    stateAdd: "",
    zipAdd: "",
    causeofLossById: [],
    causeOfLossAdd: "",
    surveyTypes: [],
    countryName: [],
    contactAdd: "",
    cCode: "Select Country Code",
    contactAddOption: "",
    emailAdd: "",
    websiteAdd: "https//:",
    contryList: [],
    alternateCCode: "Select Country Code",

    sourceByID: [],
    adminsList: [],
    usernameError: "",
    serveId: "",
    tableLoading: false,
    defaultItem: {
      Source: "",
      Reference_Number: "",
      Date: "04/05/2020",
      First_Name: "",
      Last_Name: "",
      City: "",
      County: "",
      State: "",
      Cause_Of_Loss: "",

      basedata: ""
    },
    dateFormattedView: ""
  }),
  /*For Adding new row in table */
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add" : "Edit Item";
    },
    /*for date format */
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    defaultEndDate() {
      const now = new Date();
      now.setMonth(now.getMonth());
      return new Date(now.toJSON().slice(0, 10));
    }
  },
  watch: {
    // loader() {
    //   const l = this.loader;
    //   this[l] = !this[l];

    //   setTimeout(() => (this[l] = false), 1500);

    //   this.loader = null;
    // },
    dialog(val) {
      val || this.close();
    },
    dateFormatted() {
      this.dateFormattedView = this.formatDate(this.dateFormatted);
    },
    editDate() {
      this.formatEditDate = this.formatDate(this.editDate);
    },
    date1() {
      this.dateFormatted1 = this.formatDate(this.date1);
    },
    dateAdd() {
      this.formatDateAdd = this.formatDate(this.dateAdd);
    }
  },

  created() {
    this.dateFormatted = moment()
      .subtract(2, "months")
      .format("YYYY-MM-DD");

    this.getCountry();
    this.getAllSurveyByOrgID("start");
    this.getallApiforAdd();
    this.formatView();
    this.getloginStatus();
  },
  mounted() {},
  methods: {
    alertSuccessMethod(value) {
      this.text = value;
      this.alertPositive = true;
    },
    alertErrorMethod(value) {
      this.text = value;
      this.alertNegetive = true;
    },
    async getReferenceNumValidation() {
      this.usernameError = "";
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "ReferenceNumber_CheckReferenceNumber",
        input: {
          orgid: this.$store.getters.get_orgId,
          referenceNumber: this.referenceNumberAdd
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });

        if (res.data.data.success == true) {
          this.usernameError = res.data.data.data;
        }
      } catch (error) {
        //console.log(error.response);
        return error.response;
      }
    },
    getloginStatus() {
      if (this.$store.getters.get_loginStatus == "Login Success") {
        this.alertPositive = true;
        this.text = "Login Successfully";
      }
      var sendtext = "";
      this.$store.commit("SET_loginStatus", sendtext);
    },
    getChangeStateStatus(stateStatus) {
      // console.log("mmmmmmmmmmmm", stateStatus);
      if (stateStatus.value == 0) {
        this.claimTableData = this.claimTableDataDemo.filter(
          Obj => Obj.priority == 0
        );
      } else if (stateStatus.value == 1) {
        this.claimTableData = this.claimTableDataDemo.filter(
          Obj => Obj.priority == 1
        );
      } else if (stateStatus.value == 2) {
        this.claimTableData = this.claimTableDataDemo.filter(
          Obj => Obj.priority == 2
        );
      } else if (stateStatus.value == 3) {
        this.claimTableData = this.claimTableDataDemo.filter(
          Obj => Obj.priority == 3
        );
      } else {
        this.claimTableData = this.claimTableDataDemo;
      }
    },
    editSurveys() {
      this.editdialog = false;
      this.loading3 = false;
    },
    async downloadPdf() {
      window.open(this.pdfChip);
    },
    chipsMethod(readView) {
      if (readView != true) {
        this.chip1 = false;
        this.pdfChip = [];
      }
    },
    getColor(priority) {
      if (priority == 4) return "white";
      else if (priority == 3) return "red";
      else if (priority == 2) return "orange";
      else if (priority == 1) return "blue";
      else return "green";
    },
    registerDialog() {
      this.loading2 = false;
      this.dialog = false;
      this.clearData();
    },
    getCountry() {
      // console.log(CountryJSON);
      this.countryName = CountryJSON;
      var contryListDemo = [];
      var row = {};

      var self = this;
      self.countryName.forEach(function(element) {
        // console.log(element.dial_code.replace("+", ""));
        // element.dial_code = element.dial_code.replace("+", "");
        row = {
          countryWithCC: element.name + "(" + element.dial_code + ")",
          dial_cc: element.dial_code
        };
        contryListDemo.push(row);
      });
      // console.log(contryListDemo);
      this.contryList = contryListDemo;
      //console.log(this.contryList);
    },
    formatView() {
      this.dateFormattedView = this.formatDate(this.dateFormatted);
      this.parseDate(this.dateFormattedView);
    },
    async surveyDelete() {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "DeleteSurvey_surveyDelete",
        input: {
          surveyid: this.survey_id,
          surveystatus: 0
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        var deleteServior = res;
        console.log(deleteServior);
        this.text = "Delete Successfully";
        this.alertPositive = true;
        this.serviorDelete = false;
        this.getAllSurveyByOrgID("start");
      } catch (error) {
        //console.log(error.response);
        return error.response;
      }
    },
    backmethodServeyDetails() {
      this.serveyDetails = false;
    },
    backmethod(value) {
      this.reOpenStatus = false;
      this.editdialog = false;
      this.serviorWithdraw = false;
      this.serviorDelete = false;
      this.assignSurveyor = false;
      this.activityLogStatus = false;

      this.action = "";
      this.insertActivityLog(value.surveyid, value.logCmd, value.surveyorid);
      this.getAllSurveyByOrgID("start");
    },
    async surveyWithdraw() {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "WithdrawSurvey_surveyWithdraw",
        input: {
          surveyid: this.survey_id,
          surveystatus: 7
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        var withdraw = res;
        console.log(withdraw);
        this.text = "Withdraw Successfully";
        this.alertPositive = true;
        this.serviorWithdraw = false;
        this.getAllSurveyByOrgID("start");
      } catch (error) {
        //console.log(error.response);
        return error.response;
      }
    },
    async onFilePicked(fileupload) {
      const files = fileupload;
      if (files[0] !== undefined) {
        fileupload = files[0].name;
        if (fileupload.lastIndexOf(".") <= 0) {
          return;
        }
        fileupload = [];
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        console.log(fr);
        fr.addEventListener("load", async () => {
          var imageUrl = [];
          imageUrl = fr.result.replace("data:application/pdf;base64,", "");
          console.log(imageUrl);
          var s3Client = new aws.S3({
            region: "us-east-1",
            accessKeyId: "AKIAWBVZKTFUN6FHJNUI",
            secretAccessKey: "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"
          });
          var type = 2;
          var params = {
            Bucket: "adjustermate-stage",
            Key:
              this.$store.getters.get_orgId +
              "/" +
              type +
              "/" +
              files[0].name.replace(/\s+/g, "_"),
            Body: Buffer.from(imageUrl, "base64"),
            // ContentType: contentType,
            ACL: "public-read-write"
          };

          s3Client.putObject(params, function(err, data) {
            console.log(err);
            console.log(data);
          });
        });
        var type = 2;
        var url =
          "https://adjustermate-stage.s3.amazonaws.com" +
          "/" +
          this.$store.getters.get_orgId +
          "/" +
          type +
          "/" +
          files[0].name.replace(/\s+/g, "_");
        console.log(url);
        this.registerforAdd(url);
      } else {
        this.registerforAdd(null);
      }
    },
    async updateClaim() {
      this.loading3 = true;
      if (this.$refs.form1.validate()) {
        if (typeof this.pdfChip == "object") {
          this.onFilePickedUpdate(this.pdfChip);
        } else {
          this.surveyUpdate(this.pdfChip);
        }
      } else {
        this.loading3 = false;
        this.alertNegetive = true;
        this.text = "Please Enter Mandatary Fields*";
      }
    },
    onFilePickedUpdate(fileupload) {
      const files = fileupload;
      if (files[0] !== undefined) {
        fileupload = files[0].name;
        if (fileupload.lastIndexOf(".") <= 0) {
          return;
        }
        fileupload = [];
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", async () => {
          var imageUrl = [];
          imageUrl = fr.result.replace("data:application/pdf;base64,", "");
          var s3Client = new aws.S3({
            region: "us-east-1",
            accessKeyId: "AKIAWBVZKTFUN6FHJNUI",
            secretAccessKey: "oCOJZZCUz0RZ0hp7IXg/1y9od1CGHzRS62SUoIe2"
          });
          var type = 2;
          var params = {
            Bucket: "adjustermate-stage",
            Key:
              this.$store.getters.get_orgId +
              "/" +
              type +
              "/" +
              files[0].name.replace(/\s+/g, "_"),
            Body: Buffer.from(imageUrl, "base64"),
            // ContentType: contentType,
            ACL: "public-read-write"
          };

          s3Client.putObject(params, function(err, data) {
            console.log(err);
            console.log(data);
          });
        });
        var type = 2;
        var url =
          "https://adjustermate-stage.s3.amazonaws.com" +
          "/" +
          this.$store.getters.get_orgId +
          "/" +
          type +
          "/" +
          files[0].name.replace(/\s+/g, "_");
        console.log(url);
        this.surveyUpdate(url);
      } else {
        this.surveyUpdate(url);
      }
    },
    async surveyUpdate(pdfUrlUpdate) {
      if (
        this.editFirstName.trim() == "" ||
        this.editLastName.trim() == "" ||
        this.editCompanyName.trim() == "" ||
        this.editAddress.trim() == "" ||
        this.editCity.trim() == "" ||
        this.editCounty.trim() == "" ||
        this.editState.trim() == ""
      ) {
        this.loading3 = false;
        this.alertNegetive = true;
        this.text = "No Space Allowed";
      } else {
        var input = {
          api_key: this.$store.getters.get_OrgDetails.org_apikey,
          api_password: this.$store.getters.get_OrgDetails.org_apipassword,
          command: "UpdateSurvey_surveyUpdate",
          input: {
            adminid: this.editAdmin == "" ? null : this.editAdmin,
            surveyid: this.editSurvey_id,
            surveytitle: null,
            surveydesciption: null,
            survey_orgid: this.$store.getters.get_orgId,
            cause_of_loss_id: this.editCauseOfLoss,
            reference_number: this.editReferenceNumber,
            target_state: this.editState,
            target_country: this.editCounty,
            target_city: this.editCity,
            survey_claimed_firstname: this.editFirstName,
            survey_claimed_lastname: this.editLastName,
            survey_claimed_source: this.editSource,
            company_name: this.editCompanyName,
            survey_address: this.editAddress,
            survey_zip: this.editZip,
            ccode:
              this.editCCode == "" ? null : this.editCCode.replace("+", ""),
            survey_claimed_mob_number: this.editContact,
            altnumberccode:
              this.editAlternateCode == "Select Country Code"
                ? null
                : this.editAlternateCode,
            survey_claimed_mob_number2: this.editAlternate,
            survey_claimed_website: null,
            survey_claimed_emailid: this.editEmail,
            priority: this.editPriority == "" ? null : this.editPriority,
            survey_questionid: null,
            survey_typeid: this.editType,
            survey_notes: null,
            claimDate: this.parseDate(this.formatEditDate),
            pdfurl: pdfUrlUpdate
          }
        };

        try {
          const res = await axios({
            method: "post",
            url: "http://stage.adjustermate.com/PortalServices",
            data: input
          });
          var testData = res.data.data.success;
          this.text = "Updated Successfully";
          this.alertPositive = true;
          console.log(testData);
          this.editdialog = false;
          this.loading3 = false;
          this.getAllSurveyByOrgID("start");
          this.clearData();
        } catch (error) {
          //console.log(error.response);
          return error.response;
        }
      }
    },
    async getAllSurveyorsByOrgID(serve_id) {
      this.serveId = serve_id;
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "GetSurveyors_getAllSurveyorsByOrgID",
        input: {
          surveyor_orgid: this.$store.getters.get_orgId,
          survey_id: serve_id
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        this.user = res.data.data.data;
        //console.log(this.user);
        this.assignSurveyor = true;
        //console.log(this.user);
      } catch (error) {
        //console.log(error.response);
        return error.response;
      }
    },
    actionMethod(item, actionName) {
      console.log("subha", item);
      if (actionName == "View") {
        this.getEditDataFlow(item);
        this.readonlyView = true;
        this.editdialog = true;
      }
      if (actionName == "View/Edit") {
        this.getEditDataFlow(item);
        this.readonlyView = false;
        this.editdialog = true;
      }
      if (actionName == "Assign surveyor") {
        this.getAllSurveyorsByOrgID(item.survey_id);
        this.readonlyView = false;
      }
      if (actionName == "Withdraw") {
        this.survey_id = item.survey_id;
        this.serviorWithdraw = true;
        this.readonlyView = false;
      }
      if (actionName == "Delete") {
        this.survey_id = item.survey_id;
        this.serviorDelete = true;
        this.readonlyView = false;
      }
      if (actionName == "Survey Details") {
        this.getAllgetSurveyBySurveyId(item.survey_id);
        // this.readonlyView = false;
      }
      if (actionName == "Activity Log") {
        this.getAllActivityLog(item);
        this.rowdetails = item;
      }
      if (actionName == "Re-Open") {
        this.reOpenStatus = true;
        this.rowdetails = item;
        // this.readonlyView = false;
      }

      //console.log("testing", this.action);
    },
    async getAllActivityLog(value) {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "ActivityLog_getAllActivityLog",
        input: {
          surveyid: value.survey_id,
          orgid: this.$store.getters.get_OrgDetails.org_id
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        console.log("ffffff", res.data.data.data);
        this.activityLogTable = res.data.data.data;
        this.activityLogStatus = true;
        // this.activityLodData=
      } catch (error) {
        //console.log(error.response);

        return error.response;
      }
    },
    async getAllgetSurveyBySurveyId(survey_id) {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "GetSurvey_getSurveyBySurveyId",
        input: {
          surveyid: survey_id
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        this.serveyDetailsArray = res.data.data.data;
        console.log(this.serveyDetailsArray);
        var self = this;

        self.serveyDetailsArray.forEach(function(element) {
          element.submitted_on = new Date(
            element.submitted_on
          ).toLocaleString();
        });
        this.serveyDetails = true;
      } catch (error) {
        //console.log(error.response);
        return error.response;
      }
    },
    getValueSource(survey_claimed_source, type) {
      var sourceid;
      if (type == "source") {
        this.sourceByID.forEach(function(element) {
          if (element.source_name == survey_claimed_source) {
            sourceid = element.source_id;
          }
        });
        return sourceid;
      }
      if (type == "type") {
        this.surveyTypes.forEach(function(element) {
          if (element.surveytype_name == survey_claimed_source) {
            sourceid = element.surveytype_id;
          }
        });
        return sourceid;
      }
      if (type == "loss") {
        this.causeofLossById.forEach(function(element) {
          if (element.cause_ofloss_name == survey_claimed_source) {
            sourceid = element.cause_ofloss_id;
          }
        });
        return sourceid;
      }
      if (type == "admin") {
        this.adminsList.forEach(function(element) {
          if (element.name == survey_claimed_source) {
            sourceid = element.adminid;
          }
        });
        return sourceid;
      }
      if (type == "priority") {
        this.priorityList.forEach(function(element) {
          if (element.value == survey_claimed_source) {
            sourceid = element.value;
          }
        });
        return sourceid;
      }
    },

    getEditDataFlow(itemArray) {
      (this.editSurvey_id = itemArray.survey_id),
        (this.editSource = this.getValueSource(
          itemArray.survey_claimed_source,
          "source"
        )),
        (this.editReferenceNumber = itemArray.reference_number),
        (this.formatEditDate = itemArray.survey_claimdate),
        (this.editType = this.getValueSource(itemArray.survey_type, "type")),
        (this.editFirstName = itemArray.claimed_firstname),
        (this.editLastName = itemArray.survey_claimed_lastname),
        (this.editAddress = itemArray.survey_address),
        (this.editCity = itemArray.city),
        (this.editCounty = itemArray.country),
        (this.editZip = itemArray.survey_zip),
        (this.editCauseOfLoss = this.getValueSource(
          itemArray.cause_of_loss_id,
          "loss"
        )),
        (this.editEmail = itemArray.survey_claimed_emailid),
        (this.editCCode = this.getcountryName(itemArray.ccode)),
        (this.editContact = itemArray.survey_claimed_mob_number),
        (this.editState = itemArray.state),
        (this.editCompanyName = itemArray.company_name),
        (this.editAlternateCode =
          itemArray.altnumberccode == 0
            ? "Select Country Code"
            : this.getcountryName(itemArray.altnumberccode)),
        (this.editPriority = this.getValueSource(
          itemArray.priority,
          "priority"
        )),
        (this.editAlternate =
          itemArray.survey_claimed_mob_number2 != 0
            ? itemArray.survey_claimed_mob_number2
            : null),
        (this.editWebsite = itemArray.survey_claimed_website),
        (this.editFileupload = itemArray.pdf_url.replace(/\\/g, "")),
        (this.editAdmin =
          itemArray.admin_name == ""
            ? null
            : this.getValueSource(itemArray.admin_name, "admin"));

      this.pdfChip = itemArray.pdf_url == "" ? [] : itemArray.pdf_url;

      if (itemArray.pdf_url != "") {
        this.chip1 = true;
      } else {
        this.chip1 = false;
      }
    },
    getcountryName(ccode) {
      if (ccode == 0) {
        return null;
      } else {
        ccode = "+" + ccode;
        var name;
        this.contryList.forEach(function(element) {
          if (ccode == element.dial_cc) {
            name = element.dial_cc;
          }
        });

        return name;
      }
    },
    getallApiforAdd() {
      this.getAllSourceByOrgID();
      this.getAllSurveyTypes();
      this.getAllCauseofLoss();
      this.getAllAdmins();
    },
    async getAllAdmins() {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "GetAdmins_getAllAdmins",
        input: {
          orgid: this.$store.getters.get_orgId
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        this.adminsList = res.data.data.data;
      } catch (error) {
        //console.log(error.response);
        return error.response;
      }
    },
    async getAllCauseofLoss() {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "CauseOfLoss_getAllCauseofLoss",
        input: {
          orgid: this.$store.getters.get_orgId
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        this.causeofLossById = res.data.data.data;
      } catch (error) {
        //console.log(error.response);
        return error.response;
      }
    },
    async getAllSurveyTypes() {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "TypeOfSurvey_getAllSurveyTypes",
        input: {
          orgid: this.$store.getters.get_orgId
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        this.surveyTypes = res.data.data.data;
      } catch (error) {
        //console.log(error.response);
        return error.response;
      }
    },
    async getAllSourceByOrgID() {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "GetSource_getAllSourceByOrgID",
        input: {
          orgid: this.$store.getters.get_orgId
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        this.sourceByID = res.data.data.data;
      } catch (error) {
        return error.response;
      }
    },
    async getAllSurveyByOrgID(type) {
      var input = {};
      if (type == "Go") {
        this.tableLoading = true;
        this.claimTableData = [];
        input = {
          api_key: this.$store.getters.get_OrgDetails.org_apikey,
          api_password: this.$store.getters.get_OrgDetails.org_apipassword,
          command: "GetSurvey_getAllSurveyByOrgID",

          input: {
            orgid: this.$store.getters.get_orgId,
            fromdate: this.dateFormatted,
            todate: this.parseDate(this.dateFormatted1),
            isincludeClose: this.checkboxInclude == false ? 0 : 1
          }
        };
      } else {
        this.tableLoading = true;
        input = {
          api_key: this.$store.getters.get_OrgDetails.org_apikey,
          api_password: this.$store.getters.get_OrgDetails.org_apipassword,
          command: "GetSurvey_getAllSurveyByOrgID",

          input: {
            orgid: this.$store.getters.get_orgId,
            fromdate: this.dateFormatted,
            todate: this.parseDate(this.dateFormatted1),
            isincludeClose: 1
          }
        };
      }

      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });

        if (res.data.data.success != false) {
          this.tableLoading = false;
          this.claimTableData = res.data.data.data;
          var self = this;
          self.claimTableData.forEach(function(element) {
            element.survery_date = element.survery_date.split(" ")[0];
          });
          self.claimTableData.forEach(function(element) {
            element.survey_claimdate = self.formatDate(
              element.survey_claimdate
            );
            element.survery_date = self.formatDate(element.survery_date);
          });
          this.claimTableDataDemo = this.claimTableData;
          this.loading = false;
        } else {
          this.tableLoading = false;
          this.text = "No data available";
          this.alertNegetive = true;
        }
      } catch (error) {
        //console.log(error.response);
        return error.response;
      }
    },
    clearData() {
      this.priorityAd = "";
      this.adminsListAdd = "";
      this.$refs.form.resetValidation();
      this.fileupload = [];
      this.causeOfLossAdd = "";
      this.referenceNumberAdd = "";
      this.stateAdd = "";
      this.countyAdd = "";
      this.cityAdd = "";
      this.firstNameAdd = "";
      this.lastNameAdd = "";
      this.sourceAdd = "";
      this.companyNameAdd = "";
      this.addressAdd = "";
      this.zipAdd = "";
      this.alternateCCode = "Select Country Code";
      this.cCode = "Select Country Code";
      this.contactAdd = "";
      this.contactAddOption = "";
      this.emailAdd = "";
      this.typeAdd = "";
      this.formatDateAdd = this.parseDate(this.dateAdd);

      this.adminsListAdd = "";
      this.fileupload = [];
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");

      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      // console.log(date);
      if (!date) return null;

      const [month, day, year] = date.split("/");

      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    /*Methods For adding new element to the table */
    editItem(item) {
      this.editedIndex = this.Claims.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    validateRegisterField() {
      var valid = false;
      if (
        this.firstNameAdd.trim() == "" ||
        this.lastNameAdd.trim() == "" ||
        this.companyNameAdd.trim() == "" ||
        this.addressAdd.trim() == "" ||
        this.cityAdd.trim() == "" ||
        this.stateAdd.trim() == "" ||
        this.countyAdd.trim() == ""
      ) {
        valid = false;
      } else {
        valid = true;
      }
      return valid;
    },
    async addClaim() {
      this.loading2 = true;

      if (this.$refs.form.validate()) {
        if (this.alternateCCode == undefined) {
          this.alternateCCode = "Select Country Code";
        }
        if (this.adminsListAdd == undefined) {
          this.adminsListAdd = "";
        }

        if (this.contactAddOption == undefined) {
          this.contactAddOption = "";
        }

        this.onFilePicked(this.fileupload);
      } else {
        this.loading2 = false;
        this.alertNegetive = true;

        this.text = "Please Enter Mandatary Fields*";
      }
    },
    async insertActivityLog(survey_id, type, surveyorId) {
      var input = {
        api_key: this.$store.getters.get_OrgDetails.org_apikey,
        api_password: this.$store.getters.get_OrgDetails.org_apipassword,
        command: "ActivityLog_insertActivityLog",
        input: {
          surveyid: survey_id,
          surveyorid: surveyorId,
          logCmd: type,
          logDevice: 1,
          logBy: this.$store.getters.get_OrgDetails.org_adminid,
          orgid: this.$store.getters.get_OrgDetails.org_id
        }
      };
      try {
        const res = await axios({
          method: "post",
          url: "http://stage.adjustermate.com/PortalServices",
          data: input
        });
        console.log(res);
      } catch (error) {
        //console.log(error.response);

        return error.response;
      }
    },
    async registerforAdd(pdfUrl) {
      if (this.validateRegisterField() == false) {
        this.loading2 = false;
        this.alertNegetive = true;
        this.text = "No Space Allowed";
      } else {
        var input = {
          api_key: this.$store.getters.get_OrgDetails.org_apikey,
          api_password: this.$store.getters.get_OrgDetails.org_apipassword,
          command: "CreateSurvey_createNewSurvey",
          input: {
            surveytitle: null,
            surveydesciption: null,
            survey_orgid: this.$store.getters.get_orgId,
            cause_of_loss_id: this.causeOfLossAdd,
            reference_number: this.referenceNumberAdd,
            target_state: this.stateAdd,
            target_country: this.countyAdd,
            target_city: this.cityAdd,
            survey_claimed_firstname: this.firstNameAdd,
            survey_claimed_lastname: this.lastNameAdd,
            survey_claimed_source: this.sourceAdd,
            company_name: this.companyNameAdd,
            survey_address: this.addressAdd,
            survey_zip: this.zipAdd,
            ccode: this.cCode.replace("+", ""),
            survey_claimed_mob_number: this.contactAdd,
            altnumberccode:
              this.alternateCCode != "Select Country Code"
                ? this.alternateCCode.replace("+", "")
                : null,
            survey_claimed_mob_number2:
              this.contactAddOption != "" ? this.contactAddOption : null,
            survey_claimed_emailid: this.emailAdd,
            survey_claimed_website: null,
            survey_questionid: null,
            survey_typeid: this.typeAdd,
            survey_notes: null,
            claimDate: this.parseDate(this.formatDateAdd),
            adminid: this.adminsListAdd != "" ? this.adminsListAdd : null,
            priority: this.priorityAd == "" ? null : this.priorityAd,
            pdfurl: pdfUrl
          }
        };
        try {
          const res = await axios({
            method: "post",
            url: "http://stage.adjustermate.com/PortalServices",
            data: input
          });

          if (res.data.data.data == "reference number already exits") {
            this.alertNegetive = true;
            this.text = "Reference Number Already Exits";
            this.dialog = false;
          } else if (res.data.data.success == true) {
            this.getAllSurveyByOrgID("Go");
            this.text = "Added Successfully";
            this.alertPositive = true;
            this.dialog = false;
            this.loading2 = false;
            this.priorityAd = "";
            this.insertActivityLog(res.data.data.data, "survey_add", "0");
          } else {
            this.text = "Error";
            this.dialog = false;
            this.alertNegative = true;
            this.loading2 = false;
          }
          this.loading2 = false;
          this.clearData();
          this.dialog = false;
        } catch (error) {
          //console.log(error.response);
          this.dialog = false;
          return error.response;
        }
      }
    }
  },

  /*For Search filter in the first name and last name  */
  toggleAll() {
    if (this.selected.length) this.selected = [];
    else this.selected = this.Claims.slice();
  },
  x() {
    //console.log("xx");
  },
  changeSort(column) {
    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
  },

  customFilter(items, filters, filter, headers) {
    // Init the filter class.
    const cf = new this.$MultiFilters(items, filters, filter, headers);

    cf.registerFilter("search", function(searchWord, items) {
      if (searchWord.trim() === "") return items;

      return items.filter(item => {
        return item.First_Name.toLowerCase().includes(searchWord.toLowerCase());
      }, searchWord);
    });

    cf.registerFilter("search1", function(searchWord, items) {
      if (searchWord.trim() === "") return items;

      return items.filter(item => {
        return item.Last_Name.toLowerCase().includes(searchWord.toLowerCase());
      }, searchWord);
    });

    // Its time to run all created filters.
    // Will be executed in the order thay were defined.
    return cf.runFilters();
  },

  /**
   * Handler when user input something at the "Filter" text field.
   */
  filterSearch(val) {
    this.filters = this.$MultiFilters.updateFilters(this.filters, {
      search: val
    });
  }

  /**
       * Handler when user  select some author at the "Author" select.
       
      filterAuthor(val) {
        this.filters = this.$MultiFilters.updateFilters(this.filters, {First_Name: val});
      }, */
};
</script>

<style scoped>
.text_ellipsis {
  white-space: nowrap;
  max-width: 5vw;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
#search {
  width: 100%;
  height: 100px;
  border: 1px solid lightgray;
}
.Searchrow {
  padding: -10px !important;
  margin: -10px 0px -10px -40px !important;
}
.searchbar {
  width: 150px !important;
  font-size: 14px !important;
  display: flex;
  margin-top: -10px;
  margin-left: -10px;
  padding: 10px 0px 0px 10px;
}
.searchTo {
  width: 150px !important;
  font-size: 14px !important;
  display: flex;
  margin-top: -75px;
  margin-left: 150px;
  margin-bottom: -20px;
  padding: 10px 0px 0px 10px;
}
/*style for the button inside the Add dialog Box */
#Register_Claim {
  margin-left: 39% !important;
  margin-top: -50px;
}

.v-input__control {
  min-height: 25px !important;
}
/*To Give permisiion to change the height and width of th etext fields.. */
.v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

.v-input__slot {
  align-items: center;
  justify-content: center;
}
</style>